import {ActionDataService} from '../services/action/data.service';

export class AppointmentsHelper {
  static lastSelectedDates: string[] = [];
  static userId: number;

  constructor() {
  }

  static getDbAppointments(actionDataService: ActionDataService, userId) {
    AppointmentsHelper.userId = userId;
    AppointmentsHelper.lastSelectedDates = [];
    actionDataService.getAppointments(userId).subscribe(({success, data}) => {
      if (success) {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < data.length; i++) {
          AppointmentsHelper.lastSelectedDates.push(new Date(data[i].Date).toString());
        }
      }
    });
  }

  static getUserId() {
    return AppointmentsHelper.userId;
  }

  static getAppointments(selectedDate, appointmentExists): any {

    if (AppointmentsHelper.lastSelectedDates) {
      const selectedDateHours = new Date(selectedDate).getHours();
      let selectedDateMinutes = new Date(selectedDate).getMinutes().toString();
      let selectedDateSeconds = new Date(selectedDate).getSeconds().toString();
      selectedDateSeconds = selectedDateSeconds === '0' || selectedDateSeconds === '00' ? '00' : selectedDateSeconds;
      selectedDateMinutes = selectedDateMinutes === '0' || selectedDateMinutes === '00' ? '00' : selectedDateMinutes;
      const time = selectedDateHours + ':' + selectedDateMinutes + ':' + selectedDateSeconds;

      for (let dateItem of AppointmentsHelper.lastSelectedDates) {
        const lastSelectedDatesHours = new Date(dateItem).getHours();
        let lastSelectedDatesMinutes = new Date(dateItem).getMinutes().toString();
        let lastSelectedDatesSeconds = new Date(dateItem).getSeconds().toString();
        lastSelectedDatesSeconds = lastSelectedDatesSeconds === '0' || lastSelectedDatesSeconds === '00' ? '00' : lastSelectedDatesSeconds;
        lastSelectedDatesMinutes = lastSelectedDatesMinutes === '0' || lastSelectedDatesMinutes === '00' ? '00' : lastSelectedDatesMinutes;
        const lastSelectedDatestime = lastSelectedDatesHours + ':' + lastSelectedDatesMinutes + ':' + lastSelectedDatesSeconds;

        selectedDate = selectedDate.toString().split(time)[0];
        dateItem = dateItem.split(lastSelectedDatestime)[0];
        if (dateItem === selectedDate) {
          // tslint:disable-next-line:radix
          const lastSelectedDatesMins = (lastSelectedDatesHours * 60) + parseInt(lastSelectedDatesMinutes);
          // tslint:disable-next-line:radix
          const selectedDatesMins = (selectedDateHours * 60) + parseInt(selectedDateMinutes);
          if (selectedDatesMins + 59 >= lastSelectedDatesMins && selectedDatesMins - 59 <= lastSelectedDatesMins) {
            return appointmentExists = true;
          } else {
            appointmentExists = false;
          }
        } else {
          appointmentExists = false;
        }
      }
      return appointmentExists;
    }
  }
}

